import type { FC } from 'react'
import { LoadingSpinner } from '@components/Generic'

export const Init: FC = () => {
  return (
    <div className="page-container mobile-m-0">
      <LoadingSpinner />
    </div>
  )
}
